import { atom } from "recoil";

export const DicLoaiHinhThuongMaiState = atom({
  key: "DicLoaiHinhThuongMaiState",
  default: undefined,
});
